import { Box, useTheme } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';

import { BreakPoints, Margin, Size } from '../../theme/types';
import Container from '../Container';

export { default as PageHeaderImageAndTextWrapper } from './PageHeaderImageAndTextWrapper';
export { default as PageHeaderText } from './PageHeaderText';

const defaultPercentage = 50;

interface PageHeaderProps {
  // URL to the background image
  background?: string;
  // Number between 0 and 100
  positionY?: number;
}

/**
 * Page filler with title and nav items at the top of a page
 * Stretches to big size when a background is present
 */
const PageHeader: FC<PropsWithChildren<PageHeaderProps>> = ({ children, ...props }) => {
  const theme = useTheme();

  return (
    <React.Fragment>
      <Box
        sx={{
          '& .MuiContainer-root': {
            bottom: 0,
            height: '100%',
          },
          marginBottom: theme.spacing(Margin.Large),
          marginTop: `-${theme.spacing(Margin.Medium)}`,
          backgroundImage: props.background ? `url(${props.background})` : undefined,
          backgroundPositionY: `${props.positionY ?? defaultPercentage}%`,
          ...(props.background
            ? {
                backgroundPositionX: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                height: '25vh',
                [theme.breakpoints.up(BreakPoints.Large)]: {
                  height: '30vh',
                },
                [theme.breakpoints.up(BreakPoints.XLarge)]: {
                  height: '35vh',
                },
              }
            : { height: '6em' }),
        }}
      />
      <Container size={Size.Large}>{children}</Container>
    </React.Fragment>
  );
};

export default PageHeader;
